<template>
  <div class="viewportContainer">
    <div class="viewport" ref="vp"></div>
    <div class="controls">
      <a @click="resetCamera()">Reset Camera</a>
    </div>
  </div>
  
  
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      height: 0,
      vpElement:null
    };
  },
  methods: {
    ...mapMutations(["RESIZE","RESET_CAMERA_ROTATION"]),
    ...mapActions(["INIT", "ANIMATE"]),
    resetCamera()
    {
      this.RESET_CAMERA_ROTATION();
    }
  },
  mounted() {
    this.vpElement = this.$refs.vp;
    this.INIT({
      width: this.vpElement.offsetWidth,
      height: this.vpElement.offsetHeight,
      el: this.vpElement
    }).then(() => {
      this.ANIMATE();
      window.addEventListener(
        "resize",
        () => {
          this.RESIZE({
            width: this.vpElement.offsetWidth,
            height: this.vpElement.offsetHeight
          });
        },
        true
      );
    });
  }
};
</script>

<style>
.viewportContainer{
  height: 50vh;
  width: 50vw;
/*   position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
 */
}
.viewport {
  height: 50vh;
  width: 50vw;
}
.controls
{
  color:#fff;
  padding-top: 20px;
}
.controls a
{
  cursor: pointer;
  font-size: 12px;
}
</style>
